// AppInner.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box } from "@mui/material";

// Layout components
import TopNav from "./components/TopNav";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import HomePage from "./pages/HomePage";
import SeasonsPage from "./pages/SeasonsPage";
import SchedulePage from "./pages/SchedulePage";
import StandingsPage from "./pages/StandingsPage";
import DriversPage from "./pages/DriversPage";
import TeamsPage from "./pages/TeamsPage";
import TeamPage from "./pages/TeamPage";
import RulesPage from "./pages/RulesPage";
import JoinPage from "./pages/JoinPage";
import ResultsPage from "./pages/ResultsPage";
import ImageResultsPage from "./pages/ImageResultsPage";
import NotFoundPage from "./pages/NotFoundPage";
import DriverProfilePage from "./pages/DriverProfilePage";
import LegalPage from "./pages/LegalPage";

/**
 * AppInner: shared layout shell + routing
 * Props: { appData }
 */
export default function AppInner({ appData }) {
  const navItems =
    appData?.nav ?? [];

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        backgroundImage:
          "linear-gradient(rgba(255,255,255,.018) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.018) 1px, transparent 1px)",
        backgroundSize: "48px 48px",
      }}
    >
      <TopNav navItems={navItems} />
      <ScrollToTop />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Routes>
          <Route path="/" element={<HomePage data={appData} />} />
          <Route path="/seasons" element={<SeasonsPage data={appData} />} />
          <Route path="/schedule" element={<SchedulePage data={appData} />} />
          <Route path="/standings" element={<StandingsPage data={appData} />} />
          <Route path="/drivers" element={<DriversPage data={appData} />} />
          <Route path="/teams" element={<TeamsPage data={appData} />} />
          <Route path="/team/:id" element={<TeamPage data={appData} />} />
          <Route path="/rules" element={<RulesPage data={appData} />} />
          <Route path="/results" element={<ResultsPage data={appData} />} />
          <Route path="/image-results" element={<ImageResultsPage />} />
          <Route path="/join" element={<JoinPage data={appData} />} />
          <Route path="/privacy" element={<LegalPage documentType="privacy" />} />
          <Route path="/terms" element={<LegalPage documentType="terms" />} />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/driver/:id" element={<DriverProfilePage data={appData} />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
}
